import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fingerprintStorageKey = 'mmp_fingerprint';
const nativeDeviceStorageKey = 'cinema:native-device-id';
let fingerprintPromise: Promise<string> | null = null;

function readStoredValue(key: string): string {
  try {
    return (window.localStorage.getItem(key) || '').trim();
  } catch {
    return '';
  }
}

function storeFingerprint(value: string): void {
  try {
    window.localStorage.setItem(fingerprintStorageKey, value);
  } catch {
    // The current request can still carry the fingerprint when storage is unavailable.
  }
}

function fallbackFingerprint(): string {
  const randomValue = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `fallback-${randomValue}`;
}

async function resolveClientFingerprint(): Promise<string> {
  if (typeof window === 'undefined') return '';

  const nativeDeviceID = readStoredValue(nativeDeviceStorageKey);
  if (nativeDeviceID) return nativeDeviceID;

  const stored = readStoredValue(fingerprintStorageKey);
  if (stored) return stored;

  try {
    const agent = await FingerprintJS.load();
    const result = await agent.get();
    const fingerprint = result.visitorId.trim();
    if (fingerprint) {
      storeFingerprint(fingerprint);
      return fingerprint;
    }
  } catch {
    // Fall through to a stable local identifier.
  }

  const fallback = fallbackFingerprint();
  storeFingerprint(fallback);
  return fallback;
}

export async function clientFingerprintHeaders(): Promise<Record<string, string>> {
  fingerprintPromise ??= resolveClientFingerprint();
  const fingerprint = await fingerprintPromise;
  return fingerprint ? { 'X-Client-Fingerprint': fingerprint } : {};
}
